<template>
  <div class="day-grouping-cell text-center">
    <div class="day-abbr uppercase">{{ date | moment("ddd") }}</div>
    <div class="day-date text-lg">{{ date | moment("D") }}</div>
  </div>
</template>

<script>
export default {
  name: "DayGroupingCell",
  props: {
    date: Date
  }
};
</script>

<style scoped></style>
